module.exports = __webpack_public_path__ + "från_sverige-793e84fbf3665eb699388391f7ac00e2.png";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/product-labels/från_sverige.png
// module id = 88
// module chunks = 0